import { memo, useCallback, useMemo } from 'react'
import {
  motion,
  MotionStyle,
  TargetAndTransition,
  Transition,
  VariantLabels,
  useAnimationControls,
} from 'framer-motion'

import { EReaction } from '@/src/constants/reactions'

import { useAppDispatch, useAppSelector } from '@/src/store/hooks'
import {
  removeParticipantEphemeralReaction,
  selectParticipantsReactions,
} from '@/src/store/slices/reactions'

import styles from './EphemeralReactions.module.css'

const initialAnimations: (
  left: string | number | any,
) => boolean | TargetAndTransition | VariantLabels = (left) => ({
  opacity: 0,
  y: '100%',
  left,
})

const animations: boolean | TargetAndTransition | VariantLabels = {
  opacity: [0.5, 1.2, 0],
  y: -100,
  scale: [0.5, 1.2, 1],
}

const transition: Transition = {
  duration: 2,
  ease: 'easeOut',
}

const style: MotionStyle = {
  position: 'absolute',
  fontSize: '2rem',
}

interface IEphemeralReactionsProps {
  participantIdentity: string
}

export const EphemeralReactions = memo(function EphemeralReactions({
  participantIdentity,
}: IEphemeralReactionsProps) {
  const dispatch = useAppDispatch()

  const participantsReactions = useAppSelector(selectParticipantsReactions)

  const reactions = useMemo(
    () => participantsReactions[participantIdentity]?.ephemeralReactions || [],
    [participantsReactions, participantIdentity],
  )

  if (!reactions.length) return null

  const handleAnimationComplete = (reactionId: string) => {
    dispatch(removeParticipantEphemeralReaction({ identity: participantIdentity, reactionId }))
  }

  return (
    <div className={styles?.container}>
      {reactions.map((reaction) => (
        <motion.div
          key={reaction.id}
          initial={initialAnimations(`${Math.random() * 85}%`)}
          animate={animations}
          transition={transition}
          onAnimationComplete={() => {
            handleAnimationComplete(reaction.id)
          }}
          style={style}
        >
          {EReaction[reaction.type]}
        </motion.div>
      ))}
    </div>
  )
})
